<template>
  <div>
    <PreLoader :loading="isLoading" />
    <GetInvolvedHero />
  </div>
</template>

<script setup>
import GetInvolvedHero from "@/components/GetInvolvedDir/GetInvolvedHero.vue";
import { onMounted } from "vue";
import PreLoader from "@/shared/PreLoader.vue";
import { usePreloader } from "@/composables/usePreloader";

const { isLoading, startLoading, stopLoading, waitForImages } = usePreloader();

onMounted(async () => {
  await startLoading();
  try {
    await waitForImages();
  } catch (error) {
    console.error("Error loading get involved page:", error);
  } finally {
    await stopLoading();
  }
});
</script>

<style scoped>
:deep(.preloader) {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}
</style>
